import { useEffect, useState } from 'react';
import {
  listContainerSizes,
  listContainerTypes,
  listWeightBands,
  type ContainerSize,
  type ContainerType,
  type WeightBand,
} from '../../../../reference-data/reference-data.api';
import { useJobTypeOptions } from './use-job-type-options';
import type { JobType } from '../../../../reference-data/reference-data.api';

export interface RateLineCatalogues {
  jobTypes: JobType[];
  containerSizes: ContainerSize[];
  containerTypes: ContainerType[];
  weightBands: WeightBand[];
}

/** The selects a line is keyed by, active only and fetched once while a form is open (small fixed catalogues, no server paging). A catalogue the user can't read is empty rather than an error. */
export function useRateLineCatalogues(isOpen: boolean): RateLineCatalogues {
  const jobTypes = useJobTypeOptions();
  const [cargo, setCargo] = useState<Omit<RateLineCatalogues, 'jobTypes'>>({ containerSizes: [], containerTypes: [], weightBands: [] });

  useEffect(() => {
    if (!isOpen) return;
    let cancelled = false;
    Promise.all([listContainerSizes(), listContainerTypes(), listWeightBands().catch(() => [])])
      .then(([containerSizes, containerTypes, weightBands]) => {
        if (cancelled) return;
        setCargo({
          containerSizes: containerSizes.filter((size) => size.isActive),
          containerTypes: containerTypes.filter((type) => type.isActive),
          weightBands: weightBands.filter((band) => band.isActive),
        });
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [isOpen]);

  return { jobTypes, ...cargo };
}
